import { render } from "./FlatView.vue?vue&type=template&id=6135e0f9&scoped=true&lang=pug"
import script from "./FlatView.vue?vue&type=script&lang=js"
export * from "./FlatView.vue?vue&type=script&lang=js"

import "./FlatView.vue?vue&type=style&index=0&id=6135e0f9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6135e0f9"]])

export default __exports__